"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var DateInput_1 = __importDefault(require("./DateInput"));
var DetailedItemIcon_1 = __importDefault(require("./DetailedItemIcon"));
var ItemLabel_1 = __importDefault(require("./ItemLabel"));
var lab_1 = require("@material-ui/lab");
var useStyles = (0, core_1.makeStyles)(function () {
    return (0, core_1.createStyles)({
        root: {
            display: 'flex',
            paddingTop: 7
        },
        itemContainer: {
            flexGrow: 1,
            position: 'relative',
            marginLeft: 10,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            paddingBottom: 6,
            minHeight: 36
        },
        input: {
            '& .MuiInputBase-multiline': {
                padding: 0
            },
            '& textarea': {
                padding: '10px 15px'
            },
            fontFamily: function (_a) {
                var type = _a.type;
                return type === 'textArea' ? 'Montserrat' : 'Roboto-Mono-Light';
            },
            width: '100%',
            '& .MuiFormHelperText-root': {
                position: 'absolute',
                bottom: -19
            }
        },
        info: {
            '& .MuiInputBase-multiline': {
                padding: 0
            },
            '& textarea': {
                padding: '10px 15px'
            },
            fontFamily: 'Roboto-Mono-Light',
            width: '100%',
            '& .MuiFormHelperText-root': {
                position: 'absolute',
                bottom: -19
            },
            '& input.Mui-disabled': {
                color: '#6f6f6f'
            }
        },
        button: {
            display: 'inline-block',
            padding: '8px 22px',
            textAlign: 'center',
            verticalAlign: 'middle',
            height: 36,
            minWidth: 80,
            outline: 'none',
            MozAppearance: 'none',
            fontFamily: 'Montserrat!important',
            fontSize: 16,
            lineHeight: 1,
            boxSizing: 'border-box',
            borderRadius: 5,
            border: '1px solid',
            backgroundColor: '#fff',
            color: '#8356ac',
            borderColor: function (_a) {
                var color = _a.color;
                return color;
            },
            '&.MuiButtonBase-root.Mui-disabled': {
                color: 'rgb(214 214 214)',
                borderColor: 'rgb(214 214 214)'
            }
        },
        content: {
            whiteSpace: function (_a) {
                var type = _a.type;
                return type === 'textArea' ? 'normal' : 'nowrap';
            },
            textOverflow: 'ellipsis',
            overflow: function (_a) {
                var type = _a.type, disabled = _a.disabled;
                return type === 'switch' || type === 'checkbox' || !disabled
                    ? 'visible'
                    : 'hidden';
            },
            fontSize: function (_a) {
                var type = _a.type;
                return (type === 'textArea' ? 14 : 16);
            },
            fontWeight: 400,
            color: 'black',
            textDecoration: 'none',
            '& .MuiAutocomplete-inputRoot[class*="MuiInput-root"] .MuiAutocomplete-input:first-child': {
                fontSize: 16,
                fontWeight: 400,
                paddingBottom: 0,
                fontFamily: function (_a) {
                    var type = _a.type;
                    return type === 'textArea' ? 'Montserrat' : 'Roboto-Mono-Light';
                }
            },
            '& .MuiInputBase-input': {
                fontSize: 16,
                fontWeight: 400,
                paddingBottom: 0,
                fontFamily: function (_a) {
                    var type = _a.type;
                    return type === 'textArea' ? 'Montserrat' : 'Roboto-Mono-Light';
                }
            },
            '& .MuiCheckbox-root': {
                padding: 0,
                marginLeft: -3,
                marginBottom: -3
            },
            '& .MuiSwitch-thumb': {
                color: '#ff2e00'
            },
            '& .MuiSwitch-track': {
                backgroundColor: '#ff2f0038'
            },
            '& .Mui-checked + .MuiSwitch-track': {
                backgroundColor: '#0ea9005e'
            },
            '& .MuiSwitch-colorPrimary.Mui-checked .MuiSwitch-thumb': {
                color: '#0ea900'
            },
            '& .Mui-disabled:before': {
                border: 0
            }
        }
    });
});
var DetailedItem = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var iconUrl = _a.iconUrl, label = _a.label, value = _a.value, activeItem = _a.activeItem, onChange = _a.onChange, onSelect = _a.onSelect, onClick = _a.onClick, type = _a.type, disabled = _a.disabled, xs = _a.xs, href = _a.href, target = _a.target, minValue = _a.minValue, maxValue = _a.maxValue, switchText = _a.switchText, hasError = _a.hasError, options = _a.options, helperText = _a.helperText, color = _a.color, children = _a.children, placeholder = _a.placeholder;
    var classes = useStyles({ type: type, disabled: disabled, color: color });
    var handleNumberChange = function (e) {
        var value = !isNaN(parseInt(e.target.value))
            ? parseInt(e.target.value)
            : e.target.value;
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
    };
    return (react_1.default.createElement(core_1.Grid, { item: true, xs: xs !== null && xs !== void 0 ? xs : 6, className: classes.root },
        iconUrl !== undefined && react_1.default.createElement(DetailedItemIcon_1.default, { url: iconUrl }),
        react_1.default.createElement("div", { className: classes.itemContainer },
            react_1.default.createElement(ItemLabel_1.default, null, label),
            {
                date: (react_1.default.createElement("span", { className: classes.content },
                    react_1.default.createElement(DateInput_1.default, { "aria-label": label + " Input", error: Boolean(hasError === null || hasError === void 0 ? void 0 : hasError(value)), helperText: (_b = hasError === null || hasError === void 0 ? void 0 : hasError(value)) !== null && _b !== void 0 ? _b : helperText, minDate: minValue, maxDate: maxValue, className: classes.input, disabled: disabled, value: (value !== null && value !== void 0 ? value : ''), onChange: function (dateString) {
                            onChange === null || onChange === void 0 ? void 0 : onChange(dateString);
                        } }))),
                text: (react_1.default.createElement("span", { className: classes.content },
                    react_1.default.createElement(core_1.TextField, { "aria-label": label + " Input", placeholder: placeholder, error: Boolean(hasError === null || hasError === void 0 ? void 0 : hasError(value)), helperText: (_c = hasError === null || hasError === void 0 ? void 0 : hasError(value)) !== null && _c !== void 0 ? _c : helperText, classes: { root: classes.input }, disabled: disabled, value: (_d = value) !== null && _d !== void 0 ? _d : '', onChange: function (e) { return onChange === null || onChange === void 0 ? void 0 : onChange(e.target.value); } }))),
                info: (react_1.default.createElement("span", { className: classes.content },
                    react_1.default.createElement(core_1.TextField, { error: Boolean(hasError === null || hasError === void 0 ? void 0 : hasError(value)), helperText: (_e = hasError === null || hasError === void 0 ? void 0 : hasError(value)) !== null && _e !== void 0 ? _e : helperText, classes: { root: classes.info }, disabled: true, value: (_f = value) !== null && _f !== void 0 ? _f : '', onChange: function (e) { return onChange === null || onChange === void 0 ? void 0 : onChange(e.target.value); } }))),
                autoComplete: (react_1.default.createElement("span", { className: classes.content },
                    react_1.default.createElement(lab_1.Autocomplete, { "aria-label": label + " Input", id: "autocomplete-" + label, value: activeItem, options: options !== null && options !== void 0 ? options : [], style: { width: 'auto' }, getOptionSelected: function (option, value) {
                            return option.key === (value === null || value === void 0 ? void 0 : value.key);
                        }, getOptionLabel: function (option) {
                            return option.label !== undefined ? option.label : option.key;
                        }, inputValue: (_g = value) !== null && _g !== void 0 ? _g : '', onInputChange: function (_, value, reason) {
                            if (reason === 'input' || reason === 'clear') {
                                onChange === null || onChange === void 0 ? void 0 : onChange(value);
                            }
                        }, onChange: function (_, value) {
                            var _a;
                            onChange === null || onChange === void 0 ? void 0 : onChange((_a = value === null || value === void 0 ? void 0 : value.label) !== null && _a !== void 0 ? _a : value === null || value === void 0 ? void 0 : value.key);
                            onSelect === null || onSelect === void 0 ? void 0 : onSelect(value);
                        }, getOptionDisabled: function (option) { return option.disabled; }, renderInput: function (params) {
                            var _a;
                            return (react_1.default.createElement(core_1.TextField, __assign({ error: Boolean(hasError === null || hasError === void 0 ? void 0 : hasError(value)), helperText: (_a = hasError === null || hasError === void 0 ? void 0 : hasError(value)) !== null && _a !== void 0 ? _a : helperText }, params, { classes: { root: classes.input } })));
                        } }))),
                textArea: (react_1.default.createElement("span", { "aria-label": label + " Input", className: classes.content, style: {
                        opacity: disabled ? 0.4 : 1,
                        pointerEvents: disabled ? 'none' : 'all',
                        marginTop: 10,
                        background: '#f0f0f0',
                        boxShadow: 'inset 0 1px 3px 0 rgb(0 0 0 / 10%)'
                    } },
                    react_1.default.createElement(core_1.TextField, { placeholder: placeholder, InputProps: { disableUnderline: true }, error: Boolean(hasError === null || hasError === void 0 ? void 0 : hasError(value)), helperText: (_h = hasError === null || hasError === void 0 ? void 0 : hasError(value)) !== null && _h !== void 0 ? _h : helperText, multiline: true, rows: 10, classes: { root: classes.input }, disabled: disabled, value: (_j = value) !== null && _j !== void 0 ? _j : '', onChange: function (e) { return onChange === null || onChange === void 0 ? void 0 : onChange(e.target.value); } }))),
                number: (react_1.default.createElement("span", { className: classes.content },
                    react_1.default.createElement(core_1.TextField, { "aria-label": label + " Input", placeholder: placeholder, error: Boolean(hasError === null || hasError === void 0 ? void 0 : hasError(value)), helperText: (_k = hasError === null || hasError === void 0 ? void 0 : hasError(value)) !== null && _k !== void 0 ? _k : helperText, classes: { root: classes.input }, disabled: disabled, value: (_l = value) !== null && _l !== void 0 ? _l : '', inputProps: {
                            inputMode: 'numeric',
                            pattern: '[0-9]*',
                            max: maxValue,
                            min: minValue
                        }, onChange: handleNumberChange }))),
                checkbox: (react_1.default.createElement("span", { className: classes.content },
                    react_1.default.createElement(core_1.Checkbox, { "aria-label": label + " Input", disabled: disabled, checked: value, onChange: function (e, checked) {
                            onChange === null || onChange === void 0 ? void 0 : onChange(checked);
                        }, color: 'primary' }))),
                switch: (react_1.default.createElement("span", { "aria-label": label + " Input", className: classes.content, style: {
                        marginLeft: -11,
                        marginBottom: -11
                    } },
                    react_1.default.createElement(core_1.Switch, { disabled: disabled, checked: value, onChange: function (e, checked) {
                            onChange === null || onChange === void 0 ? void 0 : onChange(checked);
                        }, color: 'primary' }),
                    switchText)),
                link: (react_1.default.createElement("a", { className: classes.content, href: href, target: target },
                    react_1.default.createElement(core_1.ButtonBase, { disabled: disabled },
                        value,
                        " \u2192"))),
                button: (react_1.default.createElement(core_1.ButtonBase, { disabled: disabled, className: classes.button, onClick: onClick !== null && onClick !== void 0 ? onClick : (function () { }) }, value)),
                console: (react_1.default.createElement("div", { className: classes.content, style: {
                        fontSize: 14,
                        marginTop: 10,
                        background: 'rgb(65, 65, 65)',
                        color: 'white',
                        boxShadow: 'rgb(0 0 0 / 10%) 0px 1px 3px 0px inset',
                        overflowY: 'auto',
                        height: 229,
                        whiteSpace: 'initial',
                        fontFamily: 'Roboto-Mono',
                        padding: '7px 10px',
                        lineHeight: 1.1
                    } }, children !== null && children !== void 0 ? children : value)),
                custom: react_1.default.createElement("div", { className: classes.content }, children)
            }[type])));
};
exports.default = react_1.default.memo(DetailedItem);
//# sourceMappingURL=DetailedItem.js.map